import { DateRange } from 'owa-datetime-utils';
import { CacheLockInfo } from '../schema/CacheLockInfo';

export type LockEvents = { [eventKey: string]: true };
export type LockInfoEntry = [string, CacheLockInfo];
export type LockInfoEntryFilter = (lockInfoEntry: LockInfoEntry) => boolean;

/** aggregate events from lockInfoEntries
 * @param lockInfoEntryFilter function to determine if a lockInfoEntry's events should be added
 * @returns events that satisfy lockInfoEntryFilter/ all events if lockInfoEntryFilter not supplied
 */
export function aggEvents(lockInfoEntryFilter: LockInfoEntryFilter = () => true) {
    return (agg: LockEvents, [key, lockInfo]: LockInfoEntry): LockEvents => {
        if (lockInfoEntryFilter([key, lockInfo])) {
            // For all the events locked by the lock add it to the map
            Object.keys(lockInfo.lockedEvents).forEach(eventId => (agg[eventId] = true));
        }
        return agg;
    };
}

/** aggregate non-null DateRanges from lockInfoEntries
 * @param lockInfoEntryFilter function to determine if a lockInfoEntry's date range should be added
 * @returns DateRanges satisfy lockInfoEntryFilter/ all non-null DateRanges if lockInfoEntryFilter not supplied
 */
export function aggDateRanges(lockInfoEntryFilter: LockInfoEntryFilter = () => true) {
    return (agg: DateRange[], [key, lockInfo]: LockInfoEntry): DateRange[] => {
        if (lockInfoEntryFilter([key, lockInfo]) && lockInfo.lockedDateRange) {
            agg.push(lockInfo.lockedDateRange);
        }
        return agg;
    };
}

export const notInLock = (lockId: string) => ([key]: LockInfoEntry) => {
    return key !== lockId;
};
